import {
  API_REQUEST,
} from '../middlewares/authMiddleware.js';
import { replace } from 'react-router-redux';

export const DETECTION_LEFTEAR_SUBMIT = Symbol('DETECTION_LEFTEAR_SUBMIT');
export const DETECTION_RIGHTEAR_SUBMIT = Symbol('DETECTION_RIGHTEAR_SUBMIT');
export const DETECTION_CLEAR_RESULT = Symbol('DETECTION_CLEAR_RESULT');
export const DETECTION_START = Symbol('DETECTION_START');
export const DETECTION_CLOSE_MODAL = Symbol('DETECTION_CLOSE_MODAL');
export const DETECTION_SENDFORM_OPEN_MODAL = Symbol('DETECTION_SENDFORM_OPEN_MODAL');
export const DETECTION_SENDFORM_CLOSE_MODAL = Symbol('DETECTION_SENDFORM_CLOSE_MODAL');
export const DETECTION_RULE_OPEN_MODAL = Symbol('DETECTION_RULE_OPEN_MODAL');
export const DETECTION_RULE_CLOSE_MODAL = Symbol('DETECTION_RULE_CLOSE_MODAL');
export const DETECTION_CREATE_MEMBER = Symbol('DETECTION_CREATE_MEMBER');
export const DETECTION_SENDED_RESULT = Symbol('DETECTION_SENDED_RESULT');

export function sendResult(customerId, result) {
  return dispatch => {
    dispatch({
      [API_REQUEST]: {
        types: [
          DETECTION_SENDED_RESULT,
        ],
        method: 'POST',
        entrypoint: `/sms/self/${customerId}`,
        json: true,
        body: {
          customerId,
          result,
        },
        onSuccess: () => {
          alert('檢驗結果成功送出');
          document.location.href='https://ear.com.tw/clinico/tw/Appointment';
        },
      },
    });
  };
}

export function createMember(tester, phone, birthday, mobilePhone, leftResult, rightResult) {
  return dispatch => {
    dispatch({
      [API_REQUEST]: {
        types: [
          DETECTION_CREATE_MEMBER,
        ],
        method: 'POST',
        entrypoint: '/customers',
        json: true,
        body: {
          name: tester,
          phone: mobilePhone,
          homeCall: phone,
          leftEar: leftResult,
          rightEar: rightResult,
          birthday: new Date(birthday),
          type: 'reservation',
        },
        dispatchPayload: {
          tester,
          mobilePhone,
          phone,
          birthday,
        },
        onSuccess: (response) => {
          if (leftResult > 55 || rightResult > 55) {
            dispatch(sendResult(response.id, 'above'));
            return;
          }

          dispatch(sendResult(response.id, 'below'));
        },
      },
    });
  };
}

export function closeRuleModal() {
  return {
    type: DETECTION_RULE_CLOSE_MODAL,
  };
}

export function openRuleModal() {
  return {
    type: DETECTION_RULE_OPEN_MODAL,
  };
}

export function closeSendFormModal() {
  return {
    type: DETECTION_SENDFORM_CLOSE_MODAL,
  };
}

export function openSendForm() {
  return {
    type: DETECTION_SENDFORM_OPEN_MODAL,
  };
}

export function closeModal() {
  return dispatch => {
    dispatch({
      type: DETECTION_CLOSE_MODAL,
    });

    dispatch(replace('/detections/test/right/step1'));
  };
}

export function setStart() {
  return {
    type: DETECTION_START,
  };
}

export function clearResult() {
  return {
    type: DETECTION_CLEAR_RESULT,
  };
}

export function setRightAnswer(level, seqNum, count) {
  return dispatch => {
    dispatch({
      type: DETECTION_RIGHTEAR_SUBMIT,
      level,
    });

    if (seqNum === count) {
      dispatch(replace('/detections/test/left/step1'));
    } else {
      dispatch(replace(`/detections/test/right/step${seqNum + 1}`));
    }
  };
}

export function setLeftAnswer(level, seqNum, count) {
  return dispatch => {
    dispatch({
      type: DETECTION_LEFTEAR_SUBMIT,
      level,
    });

    if (seqNum === count) {
      dispatch(replace('/detections/test/result'));
    } else {
      dispatch(replace(`/detections/test/left/step${seqNum + 1}`));
    }
  };
}



// WEBPACK FOOTER //
// ./actions/Detection.js